<template>
  <details-sheet :item="person" :headers="headers" v-bind="$attrs">
    <template v-slot:item.customer="{ item }">
      <span>{{ name }}</span>
      <v-btn v-if="showEyeLink" class="float-right" small icon :to="to">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
  </details-sheet>
</template>

<script>
import DetailsSheet from '@/modules/_global/_components/DetailsSheet.vue';

export default {
  name: 'CustomerDetails',

  components: {
    DetailsSheet
  },

  props: {
    person: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('DEVICES.CUSTOMER'),
          value: 'customer'
        }
      ];
    },

    name() {
      const { first_name = '', last_name = '' } = this.person;

      return `${first_name} ${last_name}`.trim();
    },

    showEyeLink() {
      return this.$route.name !== this.to.name;
    },

    to() {
      return {
        name: 'persons.show',
        params: { id: this.person.id }
      };
    }
  }
};
</script>
